export default function LogoGroup() {
  return (
    <div className="logo-group flex-center">
      <img src="meovak-logo.svg" alt="meovak logo" />
      <strong className="collapsible">Meovak</strong>
    </div>
  );
}
